import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import {
    PAYER_BORROWER,
    PAYER_LOAN_OFFICER,
    effectiveHardPullPayer,
    formatTriMergePricing,
    normalizeBorrowerPaidPolicy,
} from '../../Management/CreditReportSetup/creditPricingUtils'
import './CreditPullPaymentModal.css'

const vendorsList = {
    'KCBCredit': 'KCB Credit',
    'AdvantageCredit': 'Advantage Credit',
    'CreditTechnology': 'Credit Technology',
    'CreditTechnologies': 'Credit Technologies',
    'PremiumCreditBureau': 'Premium Credit Bureau',
    'PremiumCreditDataCDC': 'Premium Credit Data (CDC)',
    'Xactus': 'Xactus',
}

const CreditPullPaymentModal = ({
    open,
    account,
    borrowerPaidPolicy,
    paymentPreference,
    onCancel,
    onSave,
}) => {
    const policy = normalizeBorrowerPaidPolicy(borrowerPaidPolicy)
    const canChoose = policy.Enabled && policy.AllowLoOverride
    const lockedPayer = effectiveHardPullPayer(policy, null)
    const [payer, setPayer] = useState(PAYER_LOAN_OFFICER)

    useEffect(() => {
        if (!open) return
        setPayer(effectiveHardPullPayer(policy, paymentPreference))
    }, [open, borrowerPaidPolicy, paymentPreference])

    if (!account) return null

    const pricingText = formatTriMergePricing(account) || '—'
    const shownPayer = canChoose ? payer : lockedPayer

    return (
        <Modal
            className="credit-pull-payment-modal"
            open={open}
            title="Team credit account"
            footer={null}
            onCancel={onCancel}
            width={640}
        >
            <div className="cpp-body">
                <div className="cpp-account-box">
                    <div className="cpp-row">
                        <span className="cpp-label">Credit vendor:</span>
                        <span className="cpp-value">{vendorsList[account.Vendor] || account.Vendor}</span>
                    </div>
                    <div className="cpp-row">
                        <span className="cpp-label">User name:</span>
                        <span className="cpp-value">{account.Username}</span>
                    </div>
                    <div className="cpp-row">
                        <span className="cpp-label">Pricing:</span>
                        <span className="cpp-value">{pricingText}</span>
                    </div>
                    <div className="cpp-lock-line">
                        <img src="/images/user-account-lock.svg" alt="" />
                        <span>Set by your admin</span>
                    </div>
                </div>

                <div className="cpp-section-title">
                    <span>Credit pull payment</span>
                    <span className="cpp-new-badge">NEW</span>
                </div>
                <div className="cpp-section-hint">
                    {canChoose
                        ? 'Who pays for pulls you initiate. Your admin lets you choose.'
                        : 'Who pays for pulls you initiate.'}
                </div>

                {canChoose ? (
                    <div className="cpp-option-list">
                        <button
                            type="button"
                            className={`cpp-option ${payer === PAYER_LOAN_OFFICER ? 'selected' : ''}`}
                            onClick={() => setPayer(PAYER_LOAN_OFFICER)}
                        >
                            <div className="cpp-option-title">
                                <span className="cpp-radio" />
                                Loan officer pays
                            </div>
                            <div className="cpp-option-desc">Pull runs immediately on this account.</div>
                        </button>
                        <button
                            type="button"
                            className={`cpp-option ${payer === PAYER_BORROWER ? 'selected' : ''}`}
                            onClick={() => setPayer(PAYER_BORROWER)}
                        >
                            <div className="cpp-option-title">
                                <span className="cpp-radio" />
                                Borrower pays
                            </div>
                            <div className="cpp-option-desc">Borrower gets a secure payment link; the report pulls after payment.</div>
                        </button>
                    </div>
                ) : (
                    <div className="cpp-locked-option">
                        <div className="cpp-option-title">
                            {lockedPayer === PAYER_BORROWER ? 'Borrower pays' : 'Loan officer pays'}
                        </div>
                        <div className="cpp-option-desc">
                            {lockedPayer === PAYER_BORROWER
                                ? 'Borrower gets a secure payment link; the report pulls after payment.'
                                : 'Pull runs immediately on this account.'}
                        </div>
                        <div className="cpp-lock-line">
                            <img src="/images/user-account-lock.svg" alt="" />
                            <span>Set by your admin</span>
                        </div>
                    </div>
                )}

                <div className="cpp-footnote">
                    {shownPayer === PAYER_BORROWER ? (
                        <>The borrower is charged your company&apos;s vendor cost — no markup, no card surcharge. Joint reports are charged once. If a paid report cannot be completed, you request a refund for the borrower.</>
                    ) : (
                        <>Pulls are billed to your company&apos;s account with this credit vendor. The borrower is never charged and no payment link is sent.</>
                    )}
                </div>
            </div>
            <div className="cpp-footer">
                <Button
                    type="primary"
                    className="cpp-done-btn"
                    onClick={() => {
                        if (canChoose) {
                            if (onSave) onSave({ HardPullPayer: payer })
                        } else if (onCancel) {
                            onCancel()
                        }
                    }}
                >
                    Done
                </Button>
            </div>
        </Modal>
    )
}

export default CreditPullPaymentModal
